import { MouseEventHandler } from 'react';
import classNames from 'classnames/bind';
import Image from 'next/image';
import EXPAND_MORE_SRC from '../../../public/static/expand-more.svg';
import styles from './index.module.scss';

const BLOCK_NAME = 'Category-button';
const cn = classNames.bind(styles);

type TProps = {
  text: string;
  isActive?: boolean;
  isAvailable?: boolean;
  isExpanded?: boolean;
  isExpandable?: boolean;
  isDisabled?: boolean;
  onClick?: MouseEventHandler;
  isArticle?: boolean;
  id: string;
};

export const CategoryButton = ({
  text,
  onClick,
  isActive,
  isAvailable,
  isExpanded,
  isExpandable,
  isDisabled,
  isArticle,
  id,
}: TProps) => {
  return (
    <div className={styles[`${BLOCK_NAME}__wrapper`]}>
      {isExpandable && (
        <div
          className={cn(`${BLOCK_NAME}__expanded-icon`, {
            [`${BLOCK_NAME}__expanded-icon--expanded`]: isExpanded,
          })}
        >
          <Image alt="Expand" height={20} src={EXPAND_MORE_SRC} width={20} />
        </div>
      )}
      <button
        className={cn(BLOCK_NAME, {
          [`${BLOCK_NAME}--expanded`]: isExpanded,
          [`${BLOCK_NAME}--disabled`]: isDisabled,
          [`${BLOCK_NAME}--active`]: isActive,
          [`${BLOCK_NAME}--active-article`]: isActive && isArticle,
          [`${BLOCK_NAME}--available`]: !isActive && isAvailable,
        })}
        id={id}
        onClick={onClick}
        type="button"
      >
        {text}
      </button>
    </div>
  );
};
